import { Language } from './language';

const es = {
    code: Language.es,

	// HOME PAGE

	t_description: 'Niña baterista, {age} años de edad',
	t_close: 'Cerrar',

	b_home: 'Inicio',
	b_about: 'Acerca de mi',
	b_press: 'Prensa',
	b_shows: 'Presentaciones en vivo',
	b_soultone: 'Soultone',
	b_collision: 'Collision',
	b_language: 'Español',
	b_share: 'Compartir',
	b_scroll_to_top: 'Ir al inicio',
	b_click: 'Click',
	b_tap: 'Presionar',

	t_english: 'Inglés',
	t_spanish: 'Español',
	t_portuguese: 'Portugués',
	t_italian: 'Italiano',
	t_french: 'Francés',
	t_german: 'Alemán',
	t_chinese: 'Chino',

	// SHOWS PAGE

	ClassicMetal_title: 'Metal Clásico',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Presentación del dia de los abuelos 2024',
	StAlsGrandDay2024_description: 'Escuela de San Alfonso en Seattle',

	BlackViolinConcert_title: 'Concierto Black Violin con The World Your Orchestra',
	BlackViolinConcert_description: 'Teatro The Paramount',

	MexicanIndependenceDay2024_title: 'Celebracion de la Independencia de Mexico con La Orquesta Civica de Ballard',
	MexicanIndependenceDay2024_description: 'Ayuntamiento de Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival de comida del mar en Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival de comida del mar en Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Metal Moderno',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Concierto de avance de invierno 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Hair Metal',
	HairMetal_description: 'School of Rock Seattle',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Show de Talentos 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	SeasonPreviewSpring2023_title: 'Concierto de avance de primavera 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'Los Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Show de Soundtracks',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgia de los 90\'s',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Show de Talentos 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Ver aquí',

	fox_13_news_title: 'Reportaje de Fox 13 Seattle News',
	fox_13_news_description: 'Reportaje en la sección "True Northwest"',

	the_daly_migs_show_interview_title: 'Entrevista con The Daly Migs Show',
	the_daly_migs_show_interview_description: 'Entrevista acerca de ser invitada a subir al escenario con Godsmack',

	alizee_defan_07_02_2024_title: 'Entrevista con "Alizee Defan"',
	alizee_defan_07_02_2024_description: 'Entrevista exclusiva',

	jaime_mendez_news_06_26_2024_title: 'Entrevista con "Jaime Mendez News"',
	jaime_mendez_news_06_26_2024_description: 'Noticiero local de Seattle en español',

	bien_informado_03_22_2023_title: 'Artículo de "Bien Informado"',
	bien_informado_03_22_2023_description: 'Artículo de Sitio de Noticias Argentino acerca de Victoria',

	wave_potter_reaction_01_30_2023_title: 'Reacción de Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reacciona al cover de Victoria Lux Æterna de Metallica',
	
	// ABOUT PAGE

	b_back: 'Regresar',

	t_title: 'Victoria Acosta',
	t_pronouns: '(ella)',

	b_read_more: 'Leer mas',
	b_read_less: 'Leer menos',

	t_about: `
	Con las baquetas en mano y el ritmo en el alma, Victoria Acosta, de {age} años, está captando miradas y conquistando corazones como una de las jóvenes bateristas más emocionantes del momento.

Nacida en El Paso, Texas, y criada en Guadalajara, México, Victoria ahora vive en Seattle, donde sigue sorprendiendo con su dedicación extraordinaria a la música.

Su amor por la batería comenzó a los cuatro años, y desde que recibió su primer set de batería el 13 de septiembre de 2018, no ha parado. Inició su formación formal en la academia Musicalerías en Guadalajara y más tarde continuó sus estudios en Seattle, avanzando rápidamente. Tras una clase de prueba destacada en la School of Rock el 29 de mayo de 2022, fue aceptada directamente en el programa "Performers", sin pasar por el nivel principiante. Desde entonces, ha brillado en {shows} shows en vivo, deslumbrando al público con su energía contagiosa y poderosa presencia escénica.

El camino musical de Victoria va más allá del escenario. Ha grabado cientos de videos para redes sociales, ganando una comunidad de seguidores leales. El 13 de junio de 2024, fue invitada como baterista invitada por el reconocido compositor italiano Alberto Rigoni para participar en el álbum Nemesis Call. Ese mismo año, firmó un contrato de patrocinio con Soultone Cymbals el 12 de septiembre, y el 8 de marzo de 2025 se unió al grupo de artistas de Collision Drumsticks, consolidando aún más su lugar entre la nueva generación de bateristas de élite.

Además de tocar la batería, Victoria comenzó a estudiar violín en cuarto grado y, en 2024, se unió a la World Youth Orchestra. Compartió escenario con el aclamado dúo Black Violin en el Paramount Theatre, y más tarde debutó como percusionista con la Ballard Civic Orchestra en el Town Hall Seattle durante la celebración del Día de la Independencia de México.

Entre sus reconocimientos destacan el Gold Prize y el premio a la Técnica Fantástica en el concurso London Young Musician 2022, así como los premios Annual Star Musician y Outstanding Drummer Special Award en 2023.

Victoria practica todos los días, superando constantemente sus límites como baterista y violinista. Con su energía imparable y creatividad sin límites, no es solo una estrella en ascenso—es una verdadera fuerza de la naturaleza.
	`,

	// PRESS PAGE

	t_footer: 'Todos los derechos reservados',

		// SOULTONE: 

		b_visit_artist_page: 'Visita mi página de artista'

};

export default es;